require('./hireCardAtHomeAbroadStep5.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const PersonalDataHelper = require('utilities/personalDataHelper');
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname');
const { getLastNChars } = require('utilities/stringHelper');

//@commons
const { OKConsents } = require('gdpr-consents/components/OKConsents/OKConsents.js');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const WebappRender = require('components/conditionalRender/webappRender')
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const {
    ConfirmationScript,
    CONFIRMATION_SCRIPT_GREETING,
    CONFIRMATION_SCRIPT_AGREEMENT
} = require('components/contactCenter/confirmScript/confirmationScript');
const PreContractualDocumentViewer = require('components/commons/preContractualDocumentViewer/preContractualDocumentViewer');

// @components
const { GDPRSignaturePattern } = require('components/gdprSignaturePattern/gdprSignaturePattern');

// @constants
const {
    DEBIT_AT_HOME_ABROAD_STANDARD,
    DEBIT_AT_HOME_ABROAD_SUBTYPE,
    DEBIT_CARD_TYPE,
    FIFTH_STEP,
    HYPHEN,
    THIRD_STEP,
} = require('constants/index');
const { AT_HOME_ABROAD_GDPR_ID } = require('constants/gdprPlacementIds');
const {
    AT_HOME_ABROAD,
    ADD_NEW_SHIPPING_ADDRESS,
    MULTIPLE_OPERATIONS,
    messages: {AT_HOME_ABROAD_AND_GDPR}
} = require('constants/operationTypes');
const getCardsPreContractPdfData = require('constants/cardsPreContractualsPdf');
const { AT_HOME_ABROAD_PRODUCT_NAME } = require('constants/cardsPrecontractualMailInfo');

class HireCardAtHomeAbroadStep5 extends React.Component {
    componentDidMount() {
        const {
            sendPrecontractualDocumentMail,
            setTermsAndCondsText,
        } = this.props;
        const precontractualMailProductInfo = {
            productName: AT_HOME_ABROAD_PRODUCT_NAME,
            producto: DEBIT_CARD_TYPE,
            standard: DEBIT_AT_HOME_ABROAD_STANDARD,
            subproducto: DEBIT_AT_HOME_ABROAD_SUBTYPE
        };
        sendPrecontractualDocumentMail(precontractualMailProductInfo);

        if (!__CONTACT_CENTER__) {
            //This action is also called in the first step of the current hiring, if you update one remeber that maybe you should update the other one
            setTermsAndCondsText('hireCardAtHomeAbroad-hireCardAtHomeAbroad_confirmationStepAgreementText');
        }
    }

    buildSummary() {
        const {
            immAccounts,
            immHireCardAtHomeAbroad,
            immHireCardNameSelector,
            immShippingAddress,
        } = this.props;
        const selectedAccount = immHireCardAtHomeAbroad.getIn(['steps', THIRD_STEP, 'accountId']);
        const immAccount = immAccounts.getIn(['byId', selectedAccount]);
        const accountIban = getLastNChars(immAccount.get('iban'));
        const addressValue = immShippingAddress.get('isFetching') ? HYPHEN : PersonalDataHelper.getHireFormattedAddress(immShippingAddress);
        const hireCardAtAbroadClassName = contactCenterClassName('print-label', 'hire-card-at-home-abroad-step-five__summary-label')

        return (
            <div className="hire-card-at-home-abroad-step-five__summary row">
                <div className="col-xs-3">
                    <div className={hireCardAtAbroadClassName}>
                        <FormattedText value="hireCardAtHomeAbroad-summarySelectedName" />
                    </div>
                    <div className="hire-card-at-home-abroad-step-five__summary-value">
                        {immHireCardNameSelector.getIn(['names', immHireCardNameSelector.get('selectedIndex')])}
                    </div>
                </div>
                <div className="col-xs-4">
                    <div className={hireCardAtAbroadClassName}>
                        <FormattedText value="hireCardAtHomeAbroad-summarySelectedAccount" />
                    </div>
                    <div className="hire-card-at-home-abroad-step-five__summary-value">
                        <span>{immAccount.get('alias')}</span>
                        &nbsp;
                        <span>{accountIban}</span>
                    </div>
                </div>
                <div className="col-xs-5">
                    <div className={hireCardAtAbroadClassName}>
                        <FormattedText value="hireCardAtHomeAbroad-summaryShippingAddress" />
                    </div>
                    <div className="hire-card-at-home-abroad-step-five__summary-value">
                        {addressValue}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { immHireCardAtHomeAbroad, immPdfData } = this.props;
        const immStep = immHireCardAtHomeAbroad.getIn(['steps', FIFTH_STEP]);

        const params = [{
            serviceCode: AT_HOME_ABROAD
        },{
            serviceCode: ADD_NEW_SHIPPING_ADDRESS
        }];

        const agreementLabel = <FormattedText value="hireCardAtHomeAbroad-hireCardAtHomeAbroad_confirmationStepAgreementText" />;
        const agreementChecked = immStep.get('agreementChecked');
        const agreementErrorVisible = immStep.get('agreementIsDirty') && !immStep.get('agreementChecked');
        const agreementErrorMsg = formatText('hireCardAtHomeAbroad-step4CheckboxErrorMsg');
        const pdfError = immPdfData.get('errorContent');
        const operativeName = formatText('operatives-cardHireAtHomeAbroad')
        const summaryContent = this.buildSummary();
        const hireCardAtHomeTitleClassName = contactCenterClassName('print-title', 'hire-card-at-home-abroad-step-five__title')
        const hireCardAtHomeSubTitleClassName = contactCenterClassName('print-paragraph', 'hire-card-at-home-abroad-step-five__subtitle');
        const preContractDocumentInfo = getCardsPreContractPdfData()['at_home_abroad_card'];
        let agreementCheckboxContent, GDPRSignaturePatternContent;

        if(!pdfError) {
            agreementCheckboxContent = (
                <div className="hire-card-at-home-abroad-step-five__checkbox-container">
                    <WebappRender>
                        <OKCheckbox
                            idName="hireCardAtHomeAbroadAgreementCheckbox"
                            errorState={agreementErrorVisible}
                            errorMessage={agreementErrorMsg}
                            label={agreementLabel}
                            onChange={this.props.handleAgreementCheckboxChange}
                            value={agreementChecked}
                        />
                    </WebappRender>
                </div>
            )
        }

        if(agreementChecked) {
            GDPRSignaturePatternContent = (
                <GDPRSignaturePattern
                    operationType={MULTIPLE_OPERATIONS}
                    operationParams={params}
                    multiOTPMessageCode={AT_HOME_ABROAD_AND_GDPR}
                />
            )
        }

        return (
            <article className="hire-card-at-home-abroad-step-five">
                <FormattedText
                    className={hireCardAtHomeTitleClassName}
                    value="hireCardAtHomeAbroad-step4Title"
                />
                <ContactCenterRender>
                    <ConfirmationScript
                        operative={operativeName}
                        confirmationType={CONFIRMATION_SCRIPT_GREETING}
                    />
                </ContactCenterRender>
                <FormattedText
                    className={hireCardAtHomeSubTitleClassName}
                    value="hireCardAtHomeAbroad-step4Subtitle"
                />
                {summaryContent}
                <OKConsents placementId={AT_HOME_ABROAD_GDPR_ID} />
                <WebappRender>
                    <div className="hire-card-at-home-abroad-step-five__pdf-viewer-container">
                        <PreContractualDocumentViewer
                            preContractDocumentInfo={preContractDocumentInfo}
                            titleKey="preContractDocument_pdfTitlePrecontractual"
                        />
                    </div>
                </WebappRender>
                {agreementCheckboxContent}
                <ContactCenterRender>
                    <ConfirmationScript
                        confirmationType={CONFIRMATION_SCRIPT_AGREEMENT}
                    />
                </ContactCenterRender>
                {GDPRSignaturePatternContent}
            </article>
        );
    }
}

HireCardAtHomeAbroadStep5.propTypes = {
    handleAgreementCheckboxChange: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immHireCardAtHomeAbroad: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
    immPdfData: PropTypes.object.isRequired,
    immShippingAddress: PropTypes.object.isRequired,
    sendPrecontractualDocumentMail: PropTypes.func.isRequired,
    setTermsAndCondsText: PropTypes.func.isRequired,
};

module.exports = HireCardAtHomeAbroadStep5;
